import React, { useEffect } from "react";
import { assets } from "../../Assets/assets";

const PrivacyPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-white dark:bg-gray-950 overflow-hidden">

      <div
        className="absolute inset-0 opacity-[0.04] bg-repeat"
        style={{
          backgroundImage: `url(${assets.qqtlogo})`,
          backgroundSize: "180px",
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-12 text-gray-800 dark:text-gray-200">

        <h1 className="text-4xl font-bold mb-6 text-center">
          PRIVACY POLICY
        </h1>

        {/* <p className="mb-6 text-sm text-center text-gray-500">
          Effective Date: 20 April 2026
        </p> */}

        <Section title="1. Overview">
          <p>
            PCM Exports is committed to protecting user data and ensuring transparency in how information is handled.
          </p>
        </Section>

        <Section title="2. Information Collected">
          <p>a. Personal Information</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
          </ul>

          <p className="mt-3">b. Business Information</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Company name</li>
            <li>GST/IEC details</li>
            <li>Trade activity details</li>
          </ul>

          <p className="mt-3">c. Transaction Data</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Quotations requested</li>
            <li>Trade preferences</li>
            <li>Payment-related details</li>
          </ul>

          <p className="mt-3">d. Technical Data</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>IP address</li>
            <li>Device type</li>
            <li>Browser information</li>
          </ul>
        </Section>

        <Section title="2.1. SMS Permissions and OTP Data">
          <h3 className="text-lg font-semibold mt-4 mb-2">SMS PERMISSIONS:</h3>
          <p>
            Our mobile application requests permission to read and receive SMS messages
            <strong> exclusively for OTP (One-Time Password) verification.</strong>
          </p>

          <h3 className="text-lg font-semibold mt-4 mb-2">DATA COLLECTED VIA SMS:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Phone number (where OTP is sent)</li>
            <li>SMS messages containing OTP codes</li>
            <li>OTP delivery and verification timestamps</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">HOW WE USE SMS DATA:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>✓ We READ SMS messages containing OTP codes from your device</li>
            <li>✓ We EXTRACT only the 6-digit OTP code from the message</li>
            <li>✓ We AUTOMATICALLY fill the OTP input field</li>
            <li>✓ We DELETE the OTP from memory after verification</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">WHAT WE DO NOT DO WITH SMS:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>✗ We do NOT store SMS messages permanently</li>
            <li>✗ We do NOT access SMS content for any other purpose</li>
            <li>✗ We do NOT share SMS data with third parties</li>
            <li>✗ We do NOT use SMS data for marketing or analytics</li>
            <li>✗ We do NOT send SMS (we only read incoming SMS)</li>
            <li>✗ We do NOT retain SMS history on your device or servers</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">ANDROID PERMISSIONS:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>android.permission.READ_SMS:</strong> Read incoming SMS for OTP extraction</li>
            <li><strong>android.permission.RECEIVE_SMS:</strong> Detect incoming OTP messages</li>
            <li><strong>com.google.android.gms.permission.RECEIVE_SMS:</strong> Google Play Services SMS API</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">USER CONTROL:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>SMS permissions are <strong>OPTIONAL</strong></li>
            <li>You can deny SMS permission when prompted</li>
            <li>You can revoke permission anytime in Settings</li>
            <li>You can manually enter OTP without SMS permission</li>
            <li>App works fully without SMS permission</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">DATA SECURITY FOR SMS:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>All SMS processing happens locally on your device</li>
            <li>No SMS content is transmitted to our servers</li>
            <li>OTP codes are deleted immediately after verification</li>
            <li>All server communication is encrypted</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">DATA RETENTION:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>SMS messages:</strong> Deleted after OTP extraction</li>
            <li><strong>OTP codes:</strong> Deleted immediately after verification</li>
            <li><strong>Phone number:</strong> Retained in your account profile</li>
            <li><strong>Verification logs:</strong> Retained for security compliance</li>
          </ul>
        </Section>

        <Section title="3. Purpose of Data Collection">
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide AI-based quotation services</li>
            <li>Facilitate transactions</li>
            <li>Improve platform performance</li>
            <li>Ensure compliance with legal requirements</li>
            <li>Prevent fraud and misuse</li>
          </ul>
        </Section>

        <Section title="4. Legal Basis (Important for Compliance)">
          <ul className="list-disc pl-6 space-y-2">
            <li>User consent</li>
            <li>Contractual necessity</li>
            <li>Legal obligations</li>
          </ul>
        </Section>

        <Section title="5. Data Sharing">
          <ul className="list-disc pl-6 space-y-2">
            <li>Buyers/sellers involved in transactions</li>
            <li>Payment gateways (e.g., Razorpay)</li>
            <li>Logistics partners</li>
            <li>Government or regulatory authorities</li>
          </ul>
          <p>We do not sell or rent user data.</p>
        </Section>

        <Section title="6. Data Security">
          <ul className="list-disc pl-6 space-y-2">
            <li>Secure servers</li>
            <li>Encryption practices</li>
            <li>Access control systems</li>
          </ul>
          <p>However, users acknowledge that no system is fully secure.</p>
        </Section>

        <Section title="7. Cookies and Tracking">
          <ul className="list-disc pl-6 space-y-2">
            <li>Improve user experience</li>
            <li>Analyze traffic</li>
            <li>Personalize content</li>
          </ul>
          <p>Users can disable cookies via browser settings.</p>
        </Section>

        <Section title="8. User Rights">
          <ul className="list-disc pl-6 space-y-2">
            <li>Access your data</li>
            <li>Request correction</li>
            <li>Request deletion (subject to legal obligations)</li>
            <li>Withdraw consent</li>
          </ul>
        </Section>

        <Section title="9. Data Retention">
          <ul className="list-disc pl-6 space-y-2">
            <li>As long as necessary for services</li>
            <li>As required under Indian laws (tax, trade, compliance)</li>
          </ul>
        </Section>

        <Section title="10. Cross-Border Data Transfer">
          <p>
            As we facilitate international trade, data may be transferred outside India with appropriate safeguards.
          </p>
        </Section>

        <Section title="11. Updates">
          <p>We may update this policy periodically.</p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-2xl font-semibold mb-3">{title}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export default PrivacyPolicy;